module.exports = __webpack_public_path__ + "img/4.e87a4c3c.jpg";